import axios from "axios";

const apiRequest = async ({
    method,
    url,
    data
}) => {
    let token = localStorage.getItem("token_id")
    let response = null, error = null
    let options = {
        method: method,
        url: `${process.env.REACT_APP_NODE_API_URL}${url}`,
        headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data: data
    };
    await axios(options)
        .then(res => {
            response = res
        })
        .catch(err => {
            error = err
        })

    return { response, error }
}

export { apiRequest }
